// src/utils/utils_storagePurchase.ts
// Point d'entrée unique de l'action « Acheter plus d'espace ».
//
// La mécanique (choix du palier si plusieurs sont actifs, ajout au panier, ouverture
// directe du paiement) est partagée entre les 5 ressources CreatorCapacity — voir
// utils_creatorCapacityPurchase.ts. Seule cette fonction est à modifier si le point
// d'entrée change — tous les appelants suivront.

import { buyCreatorCapacity }  from "./utils_creatorCapacityPurchase";

export const BUY_STORAGE_LABEL = "Acheter plus d'espace";

/**
 * @param notify  Fonction d'affichage du message. Par défaut window.alert ;
 *                les écrans disposant d'une fenêtre applicative (régie…) passent la leur.
 */
export async function openBuyStorage(
  notify: (message: string) => void = (message) => window.alert(message)
): Promise<void> {
  return buyCreatorCapacity(
    'disk',
    "L'achat d'espace de stockage supplémentaire n'est pas encore disponible.",
    '+ de stockage',
    notify
  );
}
